import { AddressDeliveryType } from "../../models/transportation/enums/addressDeliveryType";
import { Address } from "../../models/utilities/address";
import { JsonProperty } from "../../models/utilities/json-property";
import { DeliveryHourView } from "./ship-to-address-read";

export class VendorAddress {

    public id : number = 0;

    public customerId: string = '';

    public customerName: string = 'asdf';
    
    public name : string = '';
    
    public phoneNumber : string = '';
    
    @JsonProperty({ toClass : Address })
    public address : Address = new Address();
    
    public unloadRate : number = 0;
    
    public isNew : boolean;
    
    @JsonProperty({ toClass : DeliveryHourView, designType : 'array'})
    public deliveryHours : DeliveryHourView[] = [];
    
    public rowVersion : string = '';
    
    public isJobSite: boolean = false;

    public contactEmailBusiness: string | null = null;

    public contactNameBusiness: string | null = null;

    public contactPhoneNumberBusiness: string | null = null;

    public contactEmailSite: string | null = null;

    public contactNameSite: string | null = null;

    public contactPhoneNumberSite: string | null = null;

    public note: string | null = null;

    public orderIds: string[] = [];

    public approvalUser: string | null = null;

    public approvalDate: Date | null = null;

    public reviewUser: string | null = null;

    public reviewedOn: Date | null = null;

    public isReviewed: boolean = false;

    public deliveryTypes: AddressDeliveryType[] = [];
}
